import { PaneLayouts } from '../models/pane-manager-models';

/**
 * Validates the pane layout object for valid values.
 * @param currentLayouts - The default pane layout. Used to compare the version.
 * @param value - The pane layout to validate.
 * @returns True if the pane layout is valid, false otherwise.
 */
export const isPaneLayoutValid = <T>(
  currentLayouts: PaneLayouts<T>,
  value: PaneLayouts<T>
): boolean => {
  if (!value.layouts.some((layout) => layout.label === value.activeLayoutLabel))
    return false;

  if (value.version != currentLayouts.version) return false;

  return true;
};
